import styled from 'styled-components'

export const SpinnerPlacementStyled = styled.div.attrs((props) => ({}))`
    position: relative;
    z-index: 4000;
    width: -webkit-fill-available;
    top: -20px;
`
